// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rjYyK","newExpiryDate":"styles_newExpiryDate__10kOy","footer":"styles_footer__xWKUq"};